function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * done
 */
import { Input } from 'antd';
import cx from 'classnames';
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { Text } from "../Text";
import { genTextareaStyles } from "./styles";
export var Textarea = wrapReactionHook(function (props) {
  var maxlength = props.maxlength,
    className = props.className,
    readOnly = props.readOnly,
    disabled = props.disabled,
    value = props.value;
  var prefix = 'form-textarea';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTextareaStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  if (readOnly) {
    return wrapSSR( /*#__PURE__*/React.createElement(Text, _extends({
      className: cx(hashId, prefix, "".concat(prefix, "-readonly"))
    }, props), value));
  }
  return wrapSSR( /*#__PURE__*/React.createElement(Input.TextArea, _extends({
    className: cx(hashId, prefix, className),
    maxLength: maxlength,
    disabled: disabled
  }, props)));
});